<template>
  <div id="app">
    <div v-show="this.$store.state.DLINE_ENVIRONMENT" id="devenvironment_warning" style="position:fixed;z-index:10000;top:0;width:100px;margin-left:-50px;left:50%;background-color:#ffb734;text-align:center;padding:10px;border-radius:0 0 4px 4px;opacity:.5;font-weight:bold;pointer-events:none;">测试环境</div>
    <keep-alive :include="['GoodsList']">
        <router-view v-if="$route.meta.keepAlive"></router-view>
     </keep-alive>
     <router-view v-if="!$route.meta.keepAlive"></router-view>
     <!-- <router-view></router-view> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      
    };
  },
  created() {
    let date = new Date();
    let year = date.getFullYear(); //获取当前年份
    let mon = date.getMonth() + 1; //获取当前月份
    let da = date.getDate(); //获取当前日
    let h = date.getHours(); //获取小时
    let m = date.getMinutes(); //获取分钟
    let s = date.getSeconds(); //获取秒

    let minute = m+30;

    var metaapi = document.createElement('meta');
    metaapi.httpEquiv = 'expires';
    let time = new Date( year,mon,da,h,minute,s );
    metaapi.content = time;
    document.head.appendChild(metaapi);
    
  },
  watch: {
    '$route': {
      handler(to, from){
        // console.log(to);
        // console.log(from);
        //console.log(this.$store.state.browser);
        if(this.$store.state.browser.ios && this.$store.state.browser.giantapp){
          if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual'; //改为manual之后，就不会记录滚动位置
          }
          if( !(from && from.name == "SearchList") ){ //判断哪个页面返回
            setTimeout(function(){

              if( sessionStorage.getItem('newsHeight') ){
                document.getElementById("news_content").style.minHeight = sessionStorage.getItem('newsHeight')+'px';
              }
              
              sessionStorage.removeItem('newsHeight');

              if( sessionStorage.getItem('pagesTop') ){
                document.body.scrollTop = sessionStorage.getItem('pagesTop');
                document.documentElement.scrollTop = sessionStorage.getItem('pagesTop');
                sessionStorage.removeItem('pagesTop');
              }
            },500);
          }
        }
        
      },
      immediate: true,//首次进入页面即执行
    },
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue